<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from 'vant';
export default {
  name: 'App',
  data(){
    return {
      headimgurl:null, // 头像地址
      count:0,   // 图片数量
    }
  },
  mounted:function(){
    this.getHeader()  // 获取用户头像
  },
  methods:{
    getHeader:function(){
      const wxcode = window.getPageQuery().code;
      // this.headimgurl = 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKhycujyahiaQ2ULdCVpNFtAyIYmCaJrgRhWXZMsey76Eu0Jl34iavwNhAnEtHTLqBHIYWBgic7rTCcw/0';
      // this.preloadImg(this.headimgurl.replace('/132','/0')) // 提前加载相框资源
      // 获取用户头像
      this.$axios({
        method:'get',
        url:'/api/wxuser/we-chat-authorize/wx-info',
        params:{
          appid:'wx7f9e0c1608aa309c',
          code:wxcode,
        }
      }).then((res)=>{
        if(res.data.code == 200){
          let newheadImgUrl = res.data.content.user.headImgUrl.replace('/132','/0')
          this.headimgurl = newheadImgUrl; // 获取用户头像
          console.info(this.headimgurl,'头像地址～！')
          this.preloadImg(this.headimgurl) // 提前加载相框资源
          sessionStorage.setItem('headImgUrl',this.headimgurl); // 存用户头像
          sessionStorage.setItem('openid',res.data.content.user.openid) // 存openid
          sessionStorage.setItem('mpAccessToken',res.data.content.mpAccessToken)  // 存mpAccessToken
          sessionStorage.setItem('mpRefreshToken',res.data.content.mpRefreshToken)  // 存mpRefreshToken
          WXconfig.prototype.setConfig() // 设置wx基本配置
        }else {
          if(res.data.code == 401){
            // 重新取新的code
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7f9e0c1608aa309c&redirect_uri='+encodeURIComponent("https://h5.5i5ya.com/#/")+'&response_type=code&scope=snsapi_userinfo&state=ArrailDental#wechat_redirect';
          }
        }
      }).catch((err)=>{
        console.info(err,"错误是？？")
      })
    },
    // 头像资源预加载
    preloadImg:function(headimgurl){
      let that = this;
      let imageArr = [
        require('./assets/header1.png'),
        require('./assets/header2.png'),
        require('./assets/header3.png'),
        require('./assets/header4.png'),
        require('./assets/headerMain.png'),
        // require('./assets/headerP1.png'),
        require('./assets/minHeader1.png'),
        require('./assets/minHeader2.png'),
        require('./assets/minHeader3.png'),
        require('./assets/minHeader4.png'),
        require('./assets/bottomBtn.gif'),
      ]
      imageArr.push(headimgurl);
      let image = [];
      let index = 0;
      for (const key in imageArr) {
        index += 1;
        that.count = index;
        image[index] = new Image();
        if (imageArr.hasOwnProperty(key)) {
          const img = imageArr[key];
          image[index].src = img;
        }
      }

    }
  }
};
Vue.use(Toast);
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue